
import { mapState, mapActions, mapMutations } from 'vuex';
import PaginationMixin from '@/mixins/PaginationMixin';

export default {
  mixins: [PaginationMixin],
  data() {
    return {
      columns: [
        {
          name: 'id',
          align: 'right',
          label: 'ID',
          field: 'id',
          sortable: true,
          required: true,
          format: val => `${val}`
        },
        {
          name: 'firstName',
          align: 'center',
          label: this.$t('FirstName'),
          field: 'firstName',
          headerClasses: 'entrance-col',
          sortable: true
        },
        {
          name: 'lastName',
          align: 'center',
          label: this.$t('LastName'),
          field: 'lastName',
          headerClasses: 'entrance-col',
          sortable: true
        },
        {
          name: 'userName',
          align: 'center',
          label: this.$t('Username'),
          field: 'userName',
          headerClasses: 'entrance-col',
          sortable: true
        },
        {
          name: 'emailAddress',
          align: 'center',
          label: this.$t('Email'),
          field: 'emailAddress',
          headerClasses: 'entrance-col',
          sortable: true
        },
        {
          name: 'phoneNumber',
          align: 'center',
          label: this.$t('PhoneNumber'),
          field: 'phoneNumber',
          headerClasses: 'entrance-col',
          sortable: true
        },
        {
          name: 'lastSeen',
          align: 'center',
          label: this.$t('LastSeen'),
          field: 'lastSeen',
          headerClasses: 'entrance-col'
        },
        {
          name: 'actions',
          align: 'center',
          label: this.$t('Actions'),
          field: 'actions',
          headerClasses: 'entrance-col'
        }
      ],
      row: [],
      loading: true,
      parameter: '',
      searchKeyword: ['', '', '', '', '', '']
    };
  },
  computed: {
    ...mapState('usermgmt', ['users', 'user'])
  },
  watch: {
    users() {
      this.row = this.users.map(val => {
        return {
          id: val.userID,
          firstName: val.firstName,
          lastName: val.lastName,
          userName: val.userName,
          emailAddress: val.emailAddress,
          phoneNumber: val.phoneNumber,
          lastSeen: val.lastSeen
        };
      });
    },
    searchKeyword() {
      let obj = {
        id: this.searchKeyword[0],
        firstName: this.searchKeyword[1],
        lastName: this.searchKeyword[2],
        userName: this.searchKeyword[3],
        emailAddress: this.searchKeyword[4],
        phoneNumber: this.searchKeyword[5],
        lastSeen: this.searchKeyword[6]
      };
      let rowData = this.users.map(val => {
        return {
          id: val.userID,
          firstName: val.firstName,
          lastName: val.lastName,
          userName: val.userName,
          emailAddress: val.emailAddress,
          phoneNumber: val.phoneNumber,
          lastSeen: val.lastSeen
        };
      });
      this.row = rowData.filter(v => {
        return String(v[this.parameter])
          .toLowerCase()
          .includes(obj[this.parameter].toLowerCase());
      });
    }
  },
  async created() {
    this.loading = true;
    await this.fetchUsers();
    this.loading = false;
  },
  methods: {
    ...mapActions('usermgmt', [
      'fetchUsers',
      'fetchUsersByID',
      'deleteUsersByID'
    ]),
    ...mapMutations('usermgmt', ['setDialog', 'setSettingsMode', 'setUser']),
    async fetchTableData() {
      await this.fetchAllAlertsOverview();
    },
    deleteUser(val) {
      this.$q
        .dialog({
          title: this.$t('confirmDelete'),
          message: this.$t('promptDelete'),
          cancel: true,
          persistent: false
        })
        .onOk(async () => {
          await this.deleteUsersByID(val);
          await this.fetchUsers();
          this.$q.notify({
            type: 'positive',
            position: 'top',
            message: this.$t('deleteMessage')
          });
        })
        .onCancel(() => {})
        .onDismiss(() => {});
    },
    async editMode(val) {
      await this.fetchUsersByID(val);
      await this.setSettingsMode('edit');
      this.setDialog(true);
    },
    openAddDialog() {
      this.setSettingsMode('add');
      this.setDialog(true);
      this.setUser(null);
    }
  }
};
